import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import './index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react'

// react-helmet defers head writes via requestAnimationFrame, so react-snap can
// snapshot a page before the per-page <title>/meta/canonical/OG tags are flushed.
// Disabling defer makes those writes synchronous so every prerendered route gets
// its correct head baked in.
if (Helmet.defaultProps) {
  Helmet.defaultProps.defer = false;
}

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

const app = (
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

// react-snap prerenders each route to static HTML at build time, which is what
// crawlers and social/AI scrapers read. We intentionally client-render (not
// hydrateRoot) because the app's routes are React.lazy/Suspense: their chunks
// aren't available synchronously on the client, so hydration would mismatch the
// prerendered markup. Client rendering keeps the prerendered HTML for crawlers
// while mounting cleanly for users (identical content, no hydration errors).
createRoot(rootElement).render(app);
